import type Selections from '../_steps/enums/SizeStep';
import type WizStepId from '../_steps/enums/WizStepId';
import type { StockStatus } from '../_types/inventoryTypes';
import { useChargerButtonDisabled } from './useChargerButtonDisabled';
import { useRingsButtonDisabled } from './useRingsButtonDisabled';

export interface UseButtonDisabledProps {
  currentStep: WizStepId;
  isAccessory: boolean;
  isOuraRing4Wizard: boolean;
  isLoadingPdpData: boolean;
  size: {
    value: string;
    isValid: boolean;
  };
  sizingSelector: Selections;
  stockStatus: StockStatus;
}

export const useButtonDisabled = ({
  currentStep,
  isAccessory,
  isOuraRing4Wizard,
  isLoadingPdpData,
  size,
  sizingSelector,
  stockStatus,
}: UseButtonDisabledProps) => {
  const ringsButtonDisabled = useRingsButtonDisabled({
    currentStep,
    isAccessory,
    isOuraRing4Wizard,
    isLoadingPdpData,
    size,
    sizingSelector,
    stockStatus,
  });
  const chargerButtonDisabled = useChargerButtonDisabled({
    currentStep,
    isLoadingPdpData,
    size,
    sizingSelector,
  });
  return ringsButtonDisabled || !!chargerButtonDisabled;
};
